import * as i0 from "@angular/core";
var AttrIndexService = /** @class */ (function () {
    function AttrIndexService() {
        this.primKeyCol = 'id';
        this.geomCol = 'geom';
        this.geomColManual = 'geom_manual'; // WKT string // Geometry column created for data obtained from like vectorTile, where there isn't geom column in data
        this.qaNotesColName = 'qa_notes';
        this.mapNotesColName = 'map_notes';
        this.schemaNotesColName = 'schm_notes';
        this.qaNotesGeomColName = 'geom';
        this.exceptionColName = 'exceptions';
        this.standFieldColName = 'standard_field_name';
        this.cardQcClassColName = 'qcClassName';
        this.qaErrorLevelColName = 'qa_err_level';
        // Centerline Columns // for label use, resolution center use, ...
        this.fromAddrLeftColName = 'grd_fromaddr_l';
        this.fromAddrRightColName = 'grd_fromaddr_r';
        this.toAddrLeftColName = 'grd_toaddr_l';
        this.toAddrRightColName = 'grd_toaddr_r';
        this.rdStreetNameColName = 'grd_st_name';
        this.rdLstNameColName = 'grd_lst_name';
        this.refStreetNameColName = 'full_st_name'; // street name col in ref layer
        this.addrLabelCol = 'gad_add_number';
        this.parityRightColName = 'grd_parity_r';
        this.parityLeftColName = 'grd_parity_l';
        this.addrDensityLeftColName = 'grd_density_l';
        this.addrDensityRightColName = 'grd_density_r';
        this.rdPostTypeColName = 'grd_st_postyp';
        this.rdLstTypeColName = 'grd_lst_type';
        this.rdPreTypeColName = 'grd_st_pretyp';
        this.rdPredirColName = 'grd_st_predir';
        this.rdLstPredirColName = 'grd_lst_predir';
        this.rdPosdirColName = 'grd_st_posdir';
        this.rdLstPosdirColName = 'grd_lst_posdir';
        this.rdPresepColName = 'grd_st_presep';
        this.bdryColorCol = 'gbd_color';
        this.bdryDisplayNameCol = 'gbd_dsplayname';
        this.bdryCountyNameCol = 'gbd_county';
        this.bdryStateNameCol = 'gbd_state';
        this.bdryIncNameCol = 'gbd_inc_muni';
        this.bdryUnincNameCol = 'gbd_uninc_comm';
        this.addrAddNumCol = 'gad_add_number';
        this.addrGlobalId = 'gad_globalid';
        this.addrBuildingCol = 'gad_building';
        this.addrFloorCol = 'gad_floor';
        this.addrUnitCol = 'gad_unit';
        this.addrElevationCol = 'gad_elevation';
        this.addrLongitudeCol = 'gad_longitude';
        this.addrLatitudeCol = 'gad_latitude';
        this.addrNumPrefixCol = 'gad_addnum_pre';
        this.addrNumSuffixCol = 'gad_addnum_suf';
        this.addrIdCol = 'gad_id';
        this.addNumColName = 'add_number';
        this.idColName = 'id';
        this.msagColName = 'msagcomm';
        this.esnColName = 'esn';
        this.stateColNameStandard = 'State';
        this.countyColNameStandard = 'County';
        this.stateLeftColStandard = 'State_L';
        this.stateRightColStandard = 'State_R';
        this.countyLeftColStandard = 'County_L';
        this.countyRightColStandard = 'County_R';
        this.countyNctName = 'COUNTY';
        this.stateNctName = 'STATE';
        this.tranxCreateColName = 'tranx_create';
        this.tranxDeleteColName = 'tranx_delete';
        this.a3iResultColName = 'a3i_result';
        this.a3iUpdateColName = 'a3i_update';
        this.parseInputAddrCol = 'input_addr';
        this.jsonbColumnEnd = '_attrs_nstd';
        this.jsonbColumnEnd_state = '_attrs_state';
        this.cateCodeAddress = 'ADDPTS';
        this.cateCodeCenterline = 'ROADCL';
        this.cateCodeMatchPoint = 'EDGPTS';
        this.cateCodeProvBdry = 'PROVBDY';
        this.cateCodeCounty = 'COUNTIES';
        this.cateCodeState = 'STATES';
        this.cateCodeInc = 'INC-MUNI';
        this.cateCodeUninc = 'UNINC-COMM';
        this.cateCodeFishbone = 'fishbone';
        this.isFeatOnModifyLayer = 'isOnModifyLayer'; // is feature moved to modify layer
        this.lineTopoCol = 'lineTopo'; // To store feature's topology for editing use
        this.topoLayerIsWithinEditResoKey = 'isWithinEditReso';
        this.refLayerCodeKey = 'layerCode';
        this.refLayerIdKey = 'layerId';
        this.bdryLayerCodeKey = 'layerCode';
        this.bdryLayerInfoKey = 'layerInfo'; // array of layer ids
        // readonly refLayerLabelCol = 'ref-label';
        this.attrKey = 'attributes';
        this.originalDataKey = 'originalData';
        this.drawAddrLabelKey = 'drawAddrLabel';
        this.isDeletedKey = 'isDeleted'; // deleted SHOULD NOT mean isEdited
        this.isNewDataKey = 'isNew';
        this.isIdOnlyKey = 'isIdOnly';
        this.isEditedKey = 'isEdited';
        this.idBeforeSplitKey = 'idBeforeSplit';
        this.forceShowLabelKey = 'forceShowLabel';
        this.addrRelocateNumCol = 'addrNumRelocate';
        this.sameLocationKey = 'sameLocationPoint'; // Points that have same geom location
        // Fishbone
        this.addrFishboneCol = 'gad_fishbone';
        this.fishboneCodeKey = 'fishboneCode';
        this.fishboneGeocodeCoordsByModelKey = 'fishboneGeocode'; // {L: array of coords, N: array of coords} 
        this.layerStyleKey = 'storedStyle';
        this.isFishboneSpikeKey = 'isFishboneSpike';
        this.isFishboneAddrKey = 'isFishboneAddr';
        this.isFishboneRoadKey = 'isFishboneRoad';
        //
        this.fishboneAddrUuidKey = 'fishboneAddrUuid';
        this.fishboneIdKey = 'fishboneId'; // addr uuid + first qa code
        //
        // fishboneAttrKesy = 'fishboneAttrs';
        this.isLongBoneKey = 'isLongBone';
        this.isCrossBoneKey = 'isCrossBone';
        //
        this.fishboneRcLayerIdCol = 'grd_gly_id';
        this.addrWktCol = 'gad_geom_wkt';
        this.interLayerWktCol = 'gqp_wkt';
        this.interlayerGlobalId1 = 'gqp_globalid';
        this.interlayerGlobalId2 = 'gqp_globalid2';
        this.interlayerNoteCol = 'gqp_note';
        this.rcGeomCol = 'grd_geom';
        this.rcIdCol = 'grd_id';
        // nag
        this.stnNameCol = 'stn_name';
        this.stnIdCol = 'stn_id';
        this.centroidCol = 'ngm_centroid';
        this.placenameNagName = 'PLACE_NAME';
        this.stDirectionCateName = 'ST_DIRECTION';
        this.stTypeLegacyCateName = 'ST_TYPE_LEGACY';
        // Topo
        // topoErrorTypeAttr = 'topoErrorType';
        this.topoHexColorAttr = 'hexColor';
        this.topoStrokeWidthAttr = 'strokeWidth';
        this.topoRadiusAttr = 'radius';
        // Global ID column
        this.globalIdColLower = 'globalid';
        this.globalIdColStandard = 'globalid';
        this.globalIdColInStandardSchema_lower = 'globalid';
        this.nguidCol = 'NGUID';
        this.dateUpdateCol = 'DateUpdate';
        // Discrepancy ID column
        this.discrepancyAgencyIdStandardLower = 'discrpagid';
        // dateUpdateStandardCol = 'DateUpdate';
        this.layerIdColumn = 'gly_id'; // without prefix. Different layers will add different prefix to it
        // Layer EdgePoint columns
        this.epAgencyColumn = 'gep_owner_agencies';
        this.epGeomColumn = 'gep_geom';
        this.epTranxCreateColumn = 'gep_tranx_create';
        this.epTranxDeleteColumn = 'gep_tranx_delete';
        this.epResolvedColumn = 'gep_resolved';
        // layerLoadStateTextMap: {
        // 	[state in LayerLoadState]: string
        // } = {
        // 	5: 'APPROVE',
        // 	4: 'DISAPPROVE',
        // 	3: 'SUBMIT',
        // 	2: 'CONTENT',
        // 	1.53: 'DOMAIN',
        // 	1.52: 'TOPOLOGY', // Boundary Only
        // 	1.51: 'SCHEMA',
        // 	1: 'CREATE',
        // 	0: 'Missing'
        // }
        this.cursorArrow = "url(assets/css/img/cursor_arrow.png) 10 10, auto";
        this.defaultGutterSize = 9;
        // this.addrUuidCol = 'gad_' + this.globalIdColStandard;
        this.rcUuidCol2 = 'grd_' + this.globalIdColInStandardSchema_lower + '2';
        this.rcUuidCol = 'grd_' + this.globalIdColInStandardSchema_lower;
    }
    AttrIndexService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AttrIndexService_Factory() { return new AttrIndexService(); }, token: AttrIndexService, providedIn: "root" });
    return AttrIndexService;
}());
export { AttrIndexService };
